import { StyleObject } from "styletron-react";

/** baseui layers (modals, popovers, drawers) sit above the app chrome */
export const LAYER_Z_INDEX = 4000;
/** antd popups (image preview, dropdowns, tours) must stay above the baseui layers */
export const POPUP_Z_INDEX = LAYER_Z_INDEX + 100;

export const tinyTag = {
    fontSize: "10px",
    paddingLeft: "5px",
    paddingRight: "5px",
    paddingTop: "1px",
    paddingBottom: "1px",
    marginRight: "2px",
    lineHeight: "14px",
    borderRadius: "4px",
}

export const tableHeaderStyle = {
    paddingTop: "4px",
    paddingBottom: "4px",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "32px",
}

export const fixedColumnStyle = (width: number, expandable = false, style?: any): StyleObject => {
    return {
        flex: `${ expandable ? '1' : '0'} 0 ${width}px`,
        width: width + "px",
        maxWidth: !expandable ? width + "px" : undefined,
        minWidth: width + "px",
        overflow: "hidden",
        boxSizing: "border-box",
        ...style,
    };
};